import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button } from "../../button";
import { styledWithTheme } from "../../context";
import { Row } from "../../layout";
import { px } from "../../utils";
import Th from "../html/Th";
import { CELL_SPACING_HORIZONTAL, HEADER_SPACING_VERTICAL, HEADER_SPACING_VERTICAL_REDUCED } from "../html/constants";
import { TdElement as Td } from "../html";
import { TableSpacing } from "../interfaces";
import TableContainer from "./TableContainer";
import { ACTION_BUTTON_WIDTH, TABLE_HEADER_BUTTON_BORDER_COLOR, TABLE_HEADER_BUTTON_BORDER_WIDTH, TABLE_HEADER_BUTTON_FOCUS_BORDER_COLOR } from "./constants";
export var TableContainerHorizontal = styledWithTheme(TableContainer)(function (_ref) {
  var isFocusedByTab = _ref.isFocusedByTab,
      selectors = _ref.theme.selectors;
  var NEUTRAL0 = selectors.color('neutral0');
  var NEUTRAL05 = selectors.color('neutral05');
  var backgroundGradient = "\n    linear-gradient(to right, ".concat(NEUTRAL0, ", ").concat(NEUTRAL0, "),\n    linear-gradient(to right, ").concat(NEUTRAL0, ", ").concat(NEUTRAL0, "),\n    linear-gradient(to right, ").concat(NEUTRAL05, ", ").concat(NEUTRAL0, "),\n    linear-gradient(to left, ").concat(NEUTRAL05, ", ").concat(NEUTRAL0, ")\n  ");
  return _objectSpread({
    backgroundImage: backgroundGradient,
    backgroundPosition: 'left center, right center, left center, right center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: NEUTRAL0,
    backgroundSize: '32px 100%, 32px 100%, 22px 100%, 22px 100%',
    backgroundAttachment: 'local, local, scroll, scroll',
    outline: 'none'
  }, isFocusedByTab && {
    ':focus': {
      boxShadow: "0 0 0pt 2px ".concat(selectors.color('primary80'))
    }
  });
});
export var ActionCellTh = styledWithTheme(Th)(function (_ref2) {
  var selectors = _ref2.theme.selectors;
  return {
    width: px(ACTION_BUTTON_WIDTH + 2 * selectors.space(CELL_SPACING_HORIZONTAL))
  };
});
export var ActionCellTd = ActionCellTh.withComponent(Td, {
  target: "e1o800b60"
});
export var DisabledActionButton = styledWithTheme(Button)(function (_ref3) {
  var selectors = _ref3.theme.selectors;
  return {
    borderColor: 'transparent',
    backgroundColor: 'transparent',
    margin: "auto ".concat(px(ACTION_BUTTON_WIDTH / 2), " auto auto"),
    ':focus': {
      borderColor: selectors.color('neutral70')
    },
    ':hover': {
      borderColor: selectors.color('neutral70')
    }
  };
});
export var TableHeaderButtonContent = styledWithTheme(Row)(function (_ref4) {
  var spacing = _ref4.spacing,
      textAlign = _ref4.textAlign,
      selectors = _ref4.theme.selectors;
  var paddingHorizontal = px(selectors.space(CELL_SPACING_HORIZONTAL));
  var paddingVertical = px(selectors.space(spacing === TableSpacing.Reduced ? HEADER_SPACING_VERTICAL_REDUCED : HEADER_SPACING_VERTICAL));
  return {
    padding: "".concat(paddingVertical, " ").concat(paddingHorizontal),
    textAlign: textAlign
  };
});
export var TableHeaderButtonBase = styledWithTheme('button')(function (_ref5) {
  var isFocusedByTab = _ref5.isFocusedByTab,
      selectors = _ref5.theme.selectors;
  var outlineWidth = px(TABLE_HEADER_BUTTON_BORDER_WIDTH);
  var outlineHoverColor = selectors.color(TABLE_HEADER_BUTTON_BORDER_COLOR);
  var outlineFocusColor = selectors.color(TABLE_HEADER_BUTTON_FOCUS_BORDER_COLOR);
  return _objectSpread({
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    boxSizing: 'border-box',
    color: selectors.color('neutral90'),
    cursor: 'pointer',
    fontFamily: selectors.fontFamily('primary'),
    fontSize: px(selectors.fontSize('T200')),
    fontWeight: selectors.fontWeight('regular'),
    justifyContent: 'center',
    outline: 'none',
    textAlign: 'center',
    transition: 'box-shadow .2s, border-color .2s',
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
    ':hover': {
      outline: "".concat(outlineWidth, " solid ").concat(outlineHoverColor),
      outlineOffset: "-".concat(px(TABLE_HEADER_BUTTON_BORDER_WIDTH - 1))
    }
  }, isFocusedByTab && {
    ':focus': {
      outline: "".concat(outlineWidth, " solid ").concat(outlineFocusColor),
      outlineOffset: "-".concat(px(TABLE_HEADER_BUTTON_BORDER_WIDTH - 1))
    }
  });
});